/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavCrewSettings
 */
export interface OutputUavCrewSettings {
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    altitude?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    freqControl?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    freqVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    pilot?: string;
    /**
     * RememberFlightParams — чи перезаписує подана заявка ці налаштування (за замовчуванням так).
     * @type {boolean}
     * @memberof OutputUavCrewSettings
     */
    rememberFlightParams?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    streamUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavCrewSettings
     */
    transmitterPlatformId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavCrewSettings
     */
    uavPlatformId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    uavPlatformName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    uavPlatformType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputUavCrewSettings
     */
    usesDroneId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewSettings
     */
    workType?: string;
}

/**
 * Check if a given object implements the OutputUavCrewSettings interface.
 */
export function instanceOfOutputUavCrewSettings(value: object): boolean {
    return true;
}

export function OutputUavCrewSettingsFromJSON(json: any): OutputUavCrewSettings {
    return OutputUavCrewSettingsFromJSONTyped(json, false);
}

export function OutputUavCrewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavCrewSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'altitude': json['altitude'] == null ? undefined : json['altitude'],
        'freqControl': json['freqControl'] == null ? undefined : json['freqControl'],
        'freqVideo': json['freqVideo'] == null ? undefined : json['freqVideo'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'pilot': json['pilot'] == null ? undefined : json['pilot'],
        'rememberFlightParams': json['rememberFlightParams'] == null ? undefined : json['rememberFlightParams'],
        'streamUrl': json['streamUrl'] == null ? undefined : json['streamUrl'],
        'transmitterPlatformId': json['transmitterPlatformId'] == null ? undefined : json['transmitterPlatformId'],
        'uavPlatformId': json['uavPlatformId'] == null ? undefined : json['uavPlatformId'],
        'uavPlatformName': json['uavPlatformName'] == null ? undefined : json['uavPlatformName'],
        'uavPlatformType': json['uavPlatformType'] == null ? undefined : json['uavPlatformType'],
        'usesDroneId': json['usesDroneId'] == null ? undefined : json['usesDroneId'],
        'workType': json['workType'] == null ? undefined : json['workType'],
    };
}

export function OutputUavCrewSettingsToJSON(value?: OutputUavCrewSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'altitude': value['altitude'],
        'freqControl': value['freqControl'],
        'freqVideo': value['freqVideo'],
        'phone': value['phone'],
        'pilot': value['pilot'],
        'rememberFlightParams': value['rememberFlightParams'],
        'streamUrl': value['streamUrl'],
        'transmitterPlatformId': value['transmitterPlatformId'],
        'uavPlatformId': value['uavPlatformId'],
        'uavPlatformName': value['uavPlatformName'],
        'uavPlatformType': value['uavPlatformType'],
        'usesDroneId': value['usesDroneId'],
        'workType': value['workType'],
    };
}

